import React, { useState, useEffect, useRef } from "react";
import "../assets/css/Testimonials.css";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import product1 from "../assets/images/allproducts/ageret.jpg";
import product2 from "../assets/images/allproducts/Angel-dew.jpg";
import product3 from "../assets/images/allproducts/Cutam.jpg";


const testimonials = [
  {
    id: 1,
    text: "This product has completely transformed my skin! I absolutely love the texture and quality.",
    user: "Aarohi Sharma",
    rating: 5,
    img: product1
  },
  {
    id: 2,
    text: "Amazing results within just 2 weeks! Highly recommended for sensitive skin users.",
    user: "Rahul Verma",
    rating: 4,
    img: product2
  },
  {
    id: 3,
    text: "A really premium formulation. Gives a smooth glow and hydrates very well.",
    user: "Neha Gupta",
    rating: 5,
    img: product3
  }
];

export default function TestimonialCarousel({ interval = 4000 }) {
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const timeoutRef = useRef(null);

  // Helper to clear timer
  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  // Start/reset autoplay timer
  const startTimer = () => {
    clearTimer();
    timeoutRef.current = setTimeout(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, interval);
  };

  // Autoplay effect — restarts whenever index or isPaused changes
  useEffect(() => {
    if (!isPaused) startTimer();
    return clearTimer;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, isPaused, interval]);

  // Clean up on unmount
  useEffect(() => {
    return () => clearTimer();
  }, []);

  // Manual nav
  const goTo = (i) => {
    setIndex(i);
    // restart autoplay after manual interaction
    setIsPaused(false);
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % testimonials.length);
    setIsPaused(false);
  };

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsPaused(false);
  };

  return (
    <div
      className="testimonial-section mt-5 mb-5"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onTouchStart={() => setIsPaused(true)}
      onTouchEnd={() => setIsPaused(false)}
    >
      {/* NAV BUTTONS */}
      <button className="nav-btn left" onClick={prevSlide} aria-label="Previous">
        <FaChevronLeft />
      </button>
      <button className="nav-btn right" onClick={nextSlide} aria-label="Next">
        <FaChevronRight />
      </button>

      <div
        className="testimonial-slider"
        style={{ transform: `translateX(${-index * 102}%)` }} // keep slight extra for spacing
      >
        {testimonials.map((item) => (
          <div key={item.id} className="testimonial-card" role="group" aria-roledescription="slide">
            <div className="testimonial-text-box">
              <p className="testimonial-text">“{item.text}”</p>
              <div className="testimonial-user">{item.user}</div>
              <div className="testimonial-stars" aria-hidden>
                {[...Array(item.rating)].map((_, i) => (
                  <FaStar key={i} className="star" />
                ))}
              </div>
            </div>

            <div className="testimonial-img-box">
              <img src={item.img} alt={`Product related to testimonial by ${item.user}`} />
            </div>
          </div>
        ))}
      </div>

      {/* DOTS */}
      <div className="testimonial-dots">
        {testimonials.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
